export default __webpack_public_path__ + "static/media/starsBackground3_4.64d7cffb.jpg";